// extracted by mini-css-extract-plugin
export var div = "redlyst-module--div--Lim0D";
export var img = "redlyst-module--img--QfO5+";
export var introPict = "redlyst-module--introPict--qeSe6";
export var introText = "redlyst-module--introText--uYBL1";
export var link = "redlyst-module--link--Kv1Uq";
export var media = "redlyst-module--media--WaB6x";
export var p1 = "redlyst-module--p1--2U8ri";
export var p2 = "redlyst-module--p2--2zn4x";
export var p3 = "redlyst-module--p3--9xVqI";